import React from 'react';
import { Col, Row, Container } from 'react-bootstrap';

import { Odom } from '../../HomePage/components/Highlights';
import organizationsWorkTogether from '../../../assets/images/leadersForStandardsAndSolutions/organizationsWorkTogether.png';
import setsOfDataStandards from '../../../assets/images/leadersForStandardsAndSolutions/setsOfDataStandards.png';
import greenUpArrow from '../../../assets/images/greenUpArrow.png';

const DataStandardsHighlights = () => (
  <Container style={{
    marginTop: 60
  }}>
    <Row>
      <Col xs={12} md={4}  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 30}}>
        <div style={{
          width: 240,
          height: 240,
          borderRadius: '50%',
          backgroundColor: '#DCE1CF',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <div style={{
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            top: 15
          }}>
            <img
              src={setsOfDataStandards}
              width="46px"
              height="56px"
              alt=""
            />
          </div>
          <div style={{
            margin: 25,
            marginTop: 32,
            width: 220,
            height: 220,
            borderRadius: 130,
            // backgroundColor: '#DCE1CF',
            display: 'flex',
            // alignItems: 'center',
            // justifyContent: 'center',
            flexDirection: 'column',
            fontFamily: '',
            padding: 16,
            paddingTop: 40,
          }}>
            <div style={{ height: 70 }}>
              <Odom number={3} text="" odomStyle={{
                fontSize: 60,
                fontFamily: 'montserrat bold',
                fontWeight: 'bold',
                color: '#1C1F3D',
                marginTop: 0
              }}
              />
            </div>
            <div style={{
              fontSize: 16,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#1C1F3D',
              textAlign: 'center'
            }}>
              sets of Data Standards: <span style={{ color: '#1C1F3D', fontSize: 20 }}>EDI, XML, JSON</span>
            </div>
          </div >
        </div>
      </Col>
      <Col xs={12} md={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 30}}>
        <div style={{
          width: 240,
          height: 240,
          borderRadius: '50%',
          backgroundColor: '#FDF7E0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <div style={{
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            top: 15
          }}>
            <img
              src={organizationsWorkTogether}
              width="52px"
              height="56px"
              alt=""
            />
          </div>
          <div style={{
            // margin: 25,
            // marginTop: 68,
            width: 260,
            height: 260,
            borderRadius: 130,
            // backgroundColor: '#FDF7E0',
            display: 'flex',
            // alignItems: 'center',
            // justifyContent: 'center',
            flexDirection: 'column',
            fontFamily: '',
            paddingTop: 56
          }}>
            <div style={{ height: 40, paddingTop: 4, marginTop: 8 }}>
              <Odom number={20} text="+" odomStyle={{
                fontSize: 52,
                fontFamily: 'montserrat bold',
                fontWeight: 'bold',
                color: '#1B526D',
                marginTop: 0
              }}
                textStyle={{
                  fontSize: 52,
                  fontFamily: 'montserrat bold',
                  fontWeight: 'bold',
                  color: '#1B526D',
                  marginTop: 24
                }}
              />
            </div>
            <div style={{
              fontSize: 13,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#8A9D76',
              textAlign: 'center',
              paddingTop: 24,
              paddingLeft: 4,
              paddingRight: 4
            }}>
              <span style={{ color: '#48604C', fontSize: 15 }}>ORGANIZATIONS
                WORK TOGETHER </span> DEVELOPING AND
              MAINTAINING<br />DATA
              STANDARDS
            </div>
          </div >
        </div>
      </Col>
      <Col xs={12} md={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 30}}>
        <div style={{
          width: 240,
          height: 240,
          borderRadius: '50%',
          backgroundColor: '#F3F7F8',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <div style={{
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            top: 15
          }}>
            <img
              src={greenUpArrow}
              width="56px"
              height="56px"
              alt=""
            />
          </div>
          <div style={{
            margin: 25,
            marginTop: 40,
            width: 200,
            height: 200,
            borderRadius: 130,
            // backgroundColor: '#F3F7F8',
            display: 'flex',
            // alignItems: 'center',
            // justifyContent: 'center',
            flexDirection: 'column',
            fontFamily: '',
            padding: 16,
            paddingTop: 34,
          }}>
            <div style={{ height: 72 }}>
              <Odom number={152} text="" odomStyle={{
                fontSize: 60,
                fontFamily: 'montserrat bold',
                fontWeight: 'bold',
                color: '#1B526D',
                marginTop: 0
              }}
              />
            </div>
            <div style={{
              fontSize: 16,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#1C1F3D',
              textAlign: 'center'
            }}>
              updates to Standards <span style={{ color: '#1B526D', fontSize: 20, fontFamily: 'montserrat medium' }}>in 2021</span>
            </div>
          </div >
        </div>
      </Col>
    </Row>
  </Container>
)

export default DataStandardsHighlights;
